export const ms = {
  "Add New": "Tambah baru",
  From: "Daripada",
  To: "Sehingga",
  Project: "Projek",
  project: "Projek",
  "New Project": "Projek baru",
  "Edit Project": "Edit projek",
  "Add New Project": "Tambah projek baru",
  "Project Title": "Nama projek",
  "Select Project to use": "Pilih projek",
  "New account": "Akaun baru",
  "Edit account": "Edit akaun",
  "Add New Account": "Tambah akaun baru",
  "Select Account to use": "Pilih akaun",
  "Quotation / PO / SO": "Sebut harga / PO / SO",
  "Add New Invoice": "Tambah invois baru",
  "Account Name": "Nama akaun",
  "Account Type": "Jenis akaun",
  "Parent Account": "Akaun induk",
  "Select parent account (optional)": "Pilih akaun induk (optional)",
  Transactions: "Transaksi",
  "Transaction Date": "Tarikh Invois",
  "Payment Date": "Tarikh Bayaran",
  "New sale / Other Income": "Jualan / pendapatan baru",
  "Other Invoice": "Invois lain",
  Capital: "kapital",
  "sale/Other Income": "Jualan/pendapatan",
  "New expense": "Perbelanjaan baru",
  "Due date": "Tarikh jangkaan",
  "Due Date": "Tarikh Jangkaan",
  "Payment Balance (RM)": "Baki Pembayaran",
  "Total depreciation": "Susut nilai",
  Depreciation: "Susut nilai",
  depreciation: "Susut nilai",
  Cost: "Kos",
  "depreciation (-)": "Susut nilai (-)",
  refund: "Bayaran balik pelanggan",
  "Total improvement": "Nilai tambahan",
  "Total cost required for asset improvement RM:":
    "Jumlah kos diperlukan untuk menambah kecekapan aset",
  "Total liabilities": "liabiliti",
  Ratio: "nisbah",
  "Tax Allowance": "Elaun cukai",
  Method: "Kaedah pembayaran",
  "value (RM)": "Nilai (RM)",
  "Click to view more details": "Klik untuk lebih info",
  VALUE: "Nilai",
  DEPRECIATION: "Susut Nilai",
  "CAPITAL IMPROVEMENT": "Nilai tambahan",
  LIABILITIES: "Liabiliti",
  Liabilities: "Liabiliti",
  "Total Transaction": "Jumlah transaksi",
  partner: "pelanggan/pelabur",
  Partner: "pelanggan/pelabur",
  "Partner List": "Senarai pelanggan/pelabur",
  "Group List": "Kumpulan",
  Report: "Laporan",
  Service: "Servis",
  "Waiter form": "App pelayan",
  Setting: "Tetapan",
  note: "nota",
  Note: "Nota",
  "Invoice No": "No invois",
  "Order No": "No pesanan",
  Order: "Pesanan",
  "search by order no": "No pesanan",
  "Quotation No": "No sebut harga",
  "Created At": "Tarikh disimpan",
  "Start Date": "Tarikh mula",
  "Last Update": "Kemaskini terakhir",
  "End Date": "Tarikh akhir",
  Year: "Tahun",
  "Custom range": "Julat tersuai",
  "start nett profit": "Untung permulaan",
  "Disable zakat": "Nyahaktifkan zakat",
  "Disable tax": "Nyahaktifkan cukai",
  "Enable bank sync": "Aktifkan bank penyelarasan",
  "Select Bank as default for future transactions":
    "Pilih bank sebagai default",
  "Start Date can't be ahead of end Date":
    "Tarikh mula tidak dapat melebihi tarikh akhir",
  "It will delete all associated accounts and transactions, Confirm to delete this project?":
    "Memadamkan projek akan turut memadam akaun dan transaksi",
  "This make your template (except transactions) available in template collections. Give a description/guidelines about this template":
    "In akan membuatkan templat projek anda dipaparkan di koleksi projek umum (transaksi tidak termasuk)",
  "It will delete all associated child account and transaction, Confirm delete this account?":
    "Memadam akaun ini akan turut memadam sub-akaun dan transaksi",
  info: "info",
  "Need some more data": "Sila masukkan penerangan/kegunaan projek anda",
  save: "simpan",
  saved: "Berjaya disimpan",
  "Cannot save yet": "Belum boleh disimpan",
  Approved: "Diluluskan",
  success: "Sukses",
  delete: "padam",
  create: "simpan",
  Status: "Status",
  Action: "Tindakan",
  PAID: "Bayaran selesai",
  PARTIAL: "Bayaran separa",
  UNPAID: "Belum dibayar",
  CANCELED: "Dibatalkan",
  PRINTED: "Telah dicetak",
  ACCEPTED: "Diterima",
  DRAFT: "Draf",
  Draft: "Draf",
  PROGRESS: "Proses",
  CLOSED: "Tutup",
  PENDING: "Tangguh",
  Pending: "Tangguh",
  REJECTED: "Dibatalkan",
  PENDING_REVIEW: "MENUNGGU DISEMAK OLEH ADMIN",
  GO_LIVE: "LIVE",
  SALES: "JUALAN",
  SALE: "JUALAN",
  Sale: "Jualan",
  "OTHER INCOME": "PENDAPATAN LAIN",
  "CUSTOMER DEPOSIT": "DEPOSIT PELANGGAN",
  "SUPPLIER ADVANCE": "PENDAHULUAN PEMBEKAL",
  PURCHASE: "PEMBELIAN",
  Purchase: "Pembelian",
  "New purchase": "Pembelian baru",
  "Refund & non-deductable expenses":
    "Pembayaran balik & Perbelanjaan tidak boleh ditolak",
  EXPENSES: "PERBELANJAAN",
  Expense: "Perbelanjaan",
  "Total expense": "Jumlah perbelanjaan",
  REFUND: "PEMBAYARAN BALIK",
  CAPITAL: "MODAL",
  "BUSINESS LOAN": "PINJAMAN PERNIAGAAN",
  "BUSINESS LOAN REPAYMENT": "PINJAMAN PERNIAGAAN (BAYARAN BALIK)",
  Asset: "Aset",
  "FIXED ASSET": "ASET TETAP",
  "Fixed asset": "Aset tetap",
  "New fixed asset": "Aset tetap baru",
  "CURRENT ASSET": "ASET SEMASA",
  "Current asset": "Aset semasa",
  "New current asset": "Aset semasa baru",
  "Payment Transaction": "Transaksi bayaran",
  "create & add payment details": "simpan & tambah bayaran",
  "No item, add new line": "Tiada item, tambah item baru",
  "Apply different bank": "Guna bank lain",
  "Sale/Purchase Order": "PO/SO",
  "Purchase order": "Pesanan pembelian",
  "Sale order": "Pesanan jualan",
  "New purchase/sale order": "PO/SO baru",
  "Order type": "Jenis pesanan",
  "NON-DEDUCTIBLE EXPENSES": "PERBELANJAAN TIDAK BOLEH DITOLAK",
  "DIVIDEND PAYMENT": "PEMBAYARAN DIVIDEN",
  accounts: "akaun",
  Accounts: "Akaun",
  Account: "Akaun",
  INVOICE: "INVOIS",
  invoice: "Invois",
  Invoice: "Invois",
  copy: "Salin",
  "New invoice": "Invois baru",
  payments: "Pembayaran",
  CASH: "Tunai",
  BANK_TRANSFER: "Pindahan bank",
  CHEQUE: "Cek",
  edit: "edit",
  "Showing ": "Menunjukkan ",
  " out of ": " daripada ",
  Home: "Laman utama",
  error: "ralat",
  "Something went wrong!": "Berlaku keralatan",
  Blank: "Kosong",
  "must be filled": "mesti diisi",
  "empty inputs": "Input kosong",
  "No items": "Tiada data",
  Dashboard: "Laman utama",
  Quotation: "Sebut harga",
  "New Quotation": "Sebut harga baru",
  "Add New Quotation": "Tambah sebut harga",
  Inventory: "inventori",
  inventory: "inventori",
  "Select Inventory to use": "Pilih inventory",
  ACTIVE: "AKTIF",
  CLOSE: "TUTUP",
  Deposit: "Deposit",
  "New Deposit": "Deposit baru",
  "Add New Deposit": "Tambah deposit baru",
  "Select a deposit category": "Pilih kategori deposit",
  "Select a bank": "Pilih bank",
  Loading: "Memuatkan",
  "Settle Deposit": "Selesaikan deposit",
  "Deposit amount": "Jumlah deposit",
  "Still held": "Masih dipegang",
  Allocated: "Diagihkan",
  Refunded: "Dipulangkan",
  Recognised: "Diiktiraf",
  Action: "Tindakan",
  "Allocate to existing invoice": "Agihkan ke invois sedia ada",
  "Generate a new invoice": "Jana invois baru",
  "Bill under": "Bil di bawah",
  "Select a category": "Pilih kategori",
  "Invoice amount, defaults to what is held":
    "Jumlah invois, lalai kepada baki dipegang",
  Refund: "Pulangkan",
  "Recognise as income": "Iktiraf sebagai pendapatan",
  "Release from cancelled invoice": "Lepaskan daripada invois dibatalkan",
  "This deposit is fully settled. Nothing is left to allocate, refund or recognise.":
    "Deposit ini telah diselesaikan sepenuhnya. Tiada baki untuk diagihkan, dipulangkan atau diiktiraf.",
  "From deposit": "Daripada deposit",
  "Which invoice?": "Invois yang mana?",
  "This deposit was applied to more than one invoice.":
    "Deposit ini telah digunakan untuk lebih daripada satu invois.",
  "Select an invoice": "Pilih invois",
  Open: "Buka",
  "This deposit has not been applied to any invoice yet.":
    "Deposit ini belum digunakan untuk sebarang invois.",
  "No invoice": "Tiada invois",
  Receipt: "Resit",
  "Customer Deposits": "Deposit pelanggan",
  "Supplier Advances": "Pendahuluan pembekal",
  settle: "selesaikan",
  Reference: "Rujukan",
  Partner: "Rakan niaga",
  "New Bank": "Bank baru",
  Name: "Nama",
  Type: "Jenis",
  "Account number": "Akaun number",
  "Opening balance": "Baki Awal",
  Balance: "Baki",
  "Add New Bank": "Tambah bank baru",
  "Add New Order": "Tambah pesanan baru",
  "New Order": "Pesanan baru",
  "(Waiter form)": "(Borang pelayan)",
  "Confirm delete this bank?": "Mengesahkan untuk padam bank ini?",
  deleted: "Dipadam",
  In: "Duit masuk",
  Out: "Duit keluar",
  NEW: "BARU",
  New: "Baru",
  Update: "Kemas kini",
  UPDATED: "DIKEMAS KINI",
  PAYMENT_CONFIRMED: "BAYARAN DIBUAT",
  PAYMENT_UPDATED: "BAYARAN DIKEMAS KINI",
  ORDER_DELIVERED: "PESANAN DIHANTAR",
  "Download transaction": "Muat turun transaksi",
  "All paid Invoice": "Semua invoice yang telah dibayar",
  Qty: "kuantiti",
  "Price/unit (RM)": "harga/unit (RM)",
  subTotal: "Jumlah kecil",
  "add payment details": "tambah pembayaran",
  "save & print": "simpan & print",
  "Bill Type": "Jenis bill",
  "Paid Amount": "Jumlah Dibayar",
  "Price/unit": "Harga/unit",
  "Sub Price": "Harga kecil",
  Amount: "Jumlah Bayaran",
  "Terms / Notes": "Terma / Nota",
  Items: "Barangan",
  "Total Due Now": "Jumlah Tertunggak",
  "Payment Status": "Status Pembayaran",
  "Payment Balance": "Baki bayaran",
  Change: "Baki pulangan",
  "Update product stock": "Kemas kini kuantiti stok",
  "Create & change partner": "Cipta & tukar pelanggan/pelabur",
  "partner email": "Emel pelanggan/pelabur",
  "Partner name": "Nama pelanggan/pelabur",
  "Partner handphone": "Tel pelanggan/pelabur",
  "Partner address": "Alamat pelanggan/pelabur",
  "Partner postcode": "Postcode pelanggan/pelabur",
  "Partner group": "Kumpulan pelanggan/pelabur",
  "Account type": "Jenis akaun",
  "ALL BELOW": "SEMUA DIBAWAH",
  "generate invoice": "Hasilkan invois",
  "Asset value": "Nilai aset",
  "Add New Asset": "Tambah aset baru",
  "Edit Asset": "Edit aset",
  "Total asset value RM:": "Jumlah aset RM:",
  Total: "Jumlah",
  "Total curent depreciation RM:": "Jumlah susut nilai aset semasa RM:",
  "Search partner by name, email or phone number":
    "Cari dengan nama, emel atau hp no",
  "Reference No": "No rujukan",
  "View catalog": "Lihat katalog",
  "Scan barcode": "Imbas kod bar",
  "Total Quotation RM:": "Jumlah sebut harga",
  handphone: "Tel",
  Phone: "Telefon",
  Inventories: "Inventori",
  Inventory: "Inventori",
  "New Inventory": "Inventori baru",
  products: "Produk",
  Product: "Produk",
  "New Model": "Model baru",
  "Create New Model": "Cipta model baru",
  "Add New Inventory": "Tambah inventori baru",
  "Edit Inventory": "Edit inventori",
  Close: "Tutup",
  "transaction logs": "Log transaksi",
  "barcode list": "Senarai bar kod",
  "Ready stock": "Stock sedia ada",
  "Track quantity in stock": "Jejak kuantiti stok",
  "Not tracked": "Tiada stok",
  "This item has no stock level. Use it for labour, call-out charges and anything else billed from the price list but never received into a warehouse. Selling it will not change any quantity.":
    "Item ini tiada kuantiti stok. Gunakan untuk upah, caj panggilan dan apa-apa lagi yang dibilkan dari senarai harga tetapi tidak pernah diterima masuk ke gudang. Menjualnya tidak akan mengubah sebarang kuantiti.",
  Brand: "Jenama",
  category: "kategori",
  "New Product": "Produk baru",
  Logs: "Log",
  Sell: "Jualan",
  Adjustment: "Pelarasan",
  Restock: "Restock",
  "Create New Product": "Tambah produk baru",
  Moq: "Minimum kuantiti untuk pesanan",
  "Price buy/unit": "Kos/unit",
  "Price Sell/unit": "Harga jualan/unit",
  "Insert a unique SKU prefix else will auto generated":
    "Masukkan SKU prefix atau auto dijana oleh sistem",
  "Value per unit measurement": "Nilai/unit",
  "Unit Measurement": "Unit ukuran",
  "Search by printer name": "Cari mengunakan nama printer",
  "Give a comment on quantity adjustment":
    "Masukkan nota untuk penyelarasan kuantiti",
  "all transaction associated with this product will remain as it is. Confirm delete this Product?":
    "Semua transaksi produk akan kekal.",
  "Update Product": "Edit produk",
  "New Partner": "pelanggan/pelabur baru",
  "Add New Partner": "Tambah pelanggan/pelabur baru",
  Company: "Syarikat",
  "Contact Person": "Nama wakil dihubungi",
  "Edit Partner": "Edit pelanggan/pelabur",
  Email: "Emel",
  "Last Login": "Log masuk terakhir",
  Address: "Alamat",
  Postcode: "Poskod",
  "Partner Notes": "Catatan",
  "Nothing to search for in": "Tiada apa untuk dicari dalam",
  "Use letters, numbers or a phone number":
    "Gunakan huruf, nombor atau nombor telefon",
  "The partner was not saved": "Rakan niaga TIDAK disimpan",
  "Not saved": "Tidak disimpan",
  "Check before trying again": "Semak sebelum cuba lagi",
  "Try again": "Sila cuba lagi",
  "Notes could not be loaded": "Catatan tidak dapat dimuatkan",
  Retry: "Cuba lagi",
  "e.g. bank name and account number": "cth. nama bank dan nombor akaun",
  groups: "Kumpulan",
  Group: "Kumpulan pelanggan/pelabur",
  "New Group": "Kumpulan baru",
  "Add New Group": "Tambah baru",
  "Edit Group": "Edit kunpulan",
  "Select group": "Pilih kumpulan",
  "Balance due": "Baki bayaran",
  "New Asset Payment": "Bayaran/susut nilai aset",
  "New Payment": "Bayaran baru",
  "Payment details of": "Butiran bayaran",
  "Edit Asset Payment": "Edit bayaran aset",
  "Add New Asset Payment": "Tambah bayaran aset",
  "Please select payment type": "Pilih jenis pembayaran",
  "Select Bank to use": "Pilih bank bayaran dibuat",
  "Edit Payment": "Edit bayaran",
  "Add New Payment": "Tambah bayaran baru",
  "Select report type to generate": "Pilih jenis laporan",
  generate: "Hasilkan",
  "Income Statement": "Penyata untung rugi",
  "Income statement (P&L)": "Penyata untung rugi",
  Revenues: "Pendapatan",
  revenues: "Pendapatan",
  Profit: "Untung",
  profit: "Untung",
  Lost: "kerugian",
  "Total revenue": "Jumlah pendapatan",
  "Working capital and other movements": "Modal kerja dan pergerakan lain",
  cogs: "Kos produk dijual",
  "gross profit": "Keuntungan kasar",
  expenses: "Perbelanjaan",
  "operating income": "Keuntungan operasi",
  earning: "Pendapatan bersih",
  Download: "Muat turun",
  "Cash Flow": "Penyata aliran tunai",
  "Monthly cash flow": "Aliran tunai bulanan",
  Monthly: "Bulanan",
  "Revenue top 9 customer": "Untung 9 pelanggan tertinggi",
  "Revenue top 3 customer": "Untung 3 pelanggan tertinggi",
  "Revenue top 9 product": "Untung 9 produk tertinggi",
  "Revenue top 2 product": "Untung 2 produk tertinggi",
  "account receivable": "Akaun penghutang",
  "Account receivable": "Akaun penghutang",
  "Inventory increase": "Stok sedia ada",
  "inventory (current stock - weighted)": "Inventori (Purata wajaran)",
  "Account payable": "Akaun pemiutang (jangka panjang)",
  "long term payable": "Akaun pemiutang (jangka panjang)",
  "Accrued expenses": "Perbelanjaan terkumpul (Akruan)",
  "accrued expenses": "Perbelanjaan terkumpul (Akruan)",
  "Capital expenditure": "Perbelanjaan modal",
  "Note payable": "Akaun pemiutang (semasa)",
  "note payable": "Akaun pemiutang (semasa)",
  cash: "Tunai",
  "retain earning": "Pendapatan/Kerugian tertahan",
  "Trial Balance": "Penyata imbangan duga",
  Credit: "Kredit",
  Debit: "Debit",
  "Balance Sheet": "Penyata imbangan",
  "Monthly balance sheet": "Penyata imbangan bulanan",
  Quarterly: "setiap suku tahun",
  Assets: "Aset",
  Equity: "Ekuiti",
  "Equity + Liabilities": "Ekuiti + Liabiliti",
  "property, plant & equipment": "Harta benda, tumbuhan & peralatan",
  "Sale Entry": "Entri jualan",
  "Pay & Print": "Bayar & print",
  "Remove product from partner for invoice": "Abaikan produk dari kiosk",
  "Focus barcode scanner's entry": "Fokus input pengimbas bar kod",
  "Print order by account": "Print pesanan mengikut jenis akaun",
  "Update product quantity upon order delivered":
    "Kemas kini produk kuantiti pada status pesanan dihantar",
  "Default bank": "Bank default",
  "New Printer": "Printer baru",
  Detail: "Perincian",
  "Add New Printer": "Tambah printer baru",
  Profile: "Profil",
  "Company Profile": "Profil syarikat",
  "Edit Company Profile": "Edit profil syarikat",
  Username: "Nama pengguna",
  User: "Pengguna",
  "Tax no": "No cukai",
  "Invite staff": "Jemput rakan kerja",
  Subscription: "Langganan",
  "Notification setting": "Tetapan notifikasi",
  Notification: "Notifikasi",
  Logout: "Keluar",
  Support: "Saluran sokongan",
  "Company hp": "Hp syarikat",
  "Company name": "Nama syarikat",
  "Company Address": "Alamat syarikat",
  Invite: "Jemput",
  "Notify on new invoice": "invois baru",
  "Notify on invoice update": "invois kemas kini",
  "Notify on new quotation": "sebut harga baru",
  "Notify on quotation update": "sebut harga kemas kini",
  "Notify on new order": "pesanan baru",
  "Notify on order update": "pesanan kemas kini",
  "Manage Subscription": "Urus langganan",
  "Subscribe Now": "Beli sekarang",
  "Dividen payment": "Pembayaran dividen",
  "Capital deposit": "Deposit modal",
  Device: "Peranti",
  "Do you want to create from template?": "Bina dari templat akaun?",
  Yes: "Ya",
  No: "Tidak",
  Capital: "Modal",
  "CAPITAL REPAYMENT": "MODAL (BAYARAN BALIK)",
  "BUSINESS LOAN (OUT)": "MEMBERI PINJAMAN PERNIAGAAN",
  "BUSINESS LOAN (OUT) REPAYMENT":
    "MEMBERI PINJAMAN PERNIAGAAN (BAYARAN BALIK)",
  "Last 3 months": "Sejak 3 bulan lepas",
  "Last 6 months": "Sejak 6 bulan lepas",
  "Last 12 months": "Sejak 12 bulan lepas",
  "Positive cashflow": "Positif aliran tunai",
  "Negative cashflow": "Negatif aliran tunai",
  "Copy this template": "Salinan templat ini",
  "product conciliation": "Penilaian produk",
  "Reconciliation date": "Tarikh penilaian",
  "New Conciliation": "Penilaian baru",
  documentation: "dokumentasi",
  language: "Bahasa",
  "Confirm to delete this transaction?": "Padam transaksi ini?",
  "Confirm to delete this Asset": "Padam aset ini?",
  "Monthly income statement report": "laporan penyata pendapatan bulanan",
  "Effecting date": "Tarikh penyata terkesan",
  "Missing order config, please setup order configuration":
    "Sila tetapkan tetapan order dahulu",
  "Import transactions": "Import transaksi",
  "download csv template": "Muat turun templat csv",
  "upload transactions (csv)": "Muat naik transaksi csv",
  "Copy below akaun detail for later reference":
    "Salin detail akaun di bawah untuk digunakan dalam templat",
  "Count cogs direct from purchase invoices":
    "Kira cogs terus dari invoise pembelian",
  "Issue Date": "Tarikh Dikeluarkan",
  transfer: "Pindah wang",
  "Transfer Fund": "Pemindahan Wang",
  "more details": "extra",
  "Balance B/F": "Baki B/H",
  "Total Debit": "Jumlah Debit",
  "Total Credit": "Jumlah Credit",
  "Adjustment Notes": "Nota Pelarasan",
  "New Credit Note": "Nota Kredit Baharu",
  "Add New Credit Note": "Tambah Nota Kredit Baharu",
  "Note type": "Jenis nota",
  "Credit note": "Nota kredit",
  "Note no": "No nota",
  "Against invoice": "Terhadap invois",
  Goods: "Barang",
  "Returned, resaleable": "Dipulangkan, boleh dijual semula",
  "Returned, damaged": "Dipulangkan, rosak",
  "No goods returned": "Tiada barang dipulangkan",
  "Lines to credit": "Baris untuk dikreditkan",
  Creditable: "Boleh dikredit",
  of: "daripada",
  "Invoice value": "Nilai invois",
  "Outstanding after this note": "Baki selepas nota ini",
  "Issue Note": "Keluarkan Nota",
  "Refund note": "Nota bayaran balik",
  supplier: "pembekal",
  "Record Supplier Credit Note": "Rekod Nota Kredit Pembekal",
  "Record Note": "Rekod Nota",
  "Supplier's note number": "No nota pembekal",
  // Milestone 9 -- self-billed notes. Specific Guideline v4.7 section 8.3.
  "Who issues this note": "Siapa mengeluarkan nota ini",
  // Milestone 10 -- the RM10,000 consolidation ceiling, surfaced as a warning.
  "of them exceed RM10,000 and cannot be consolidated. Submit those individually.":
    "daripadanya melebihi RM10,000 dan tidak boleh disatukan. Hantar dokumen tersebut secara individu.",
  "Submit to LHDN": "Hantar ke LHDN",
  "IRBM reference": "Rujukan IRBM",
  "Recorded from supplier": "Direkodkan daripada pembekal",
  "Self-billed: agent, dealer or distributor":
    "Bil sendiri: ejen, penjual atau pengedar",
  "Self-billed: foreign supplier": "Bil sendiri: pembekal luar negara",
  "Self-billed: profit distribution": "Bil sendiri: pengagihan keuntungan",
  "Self-billed: e-commerce": "Bil sendiri: e-dagang",
  "Self-billed: betting or gaming pay-out":
    "Bil sendiri: bayaran pertaruhan atau permainan",
  "Self-billed: individual not conducting a business":
    "Bil sendiri: individu yang tidak menjalankan perniagaan",
  "Self-billed: interest payment": "Bil sendiri: bayaran faedah",
  "Self-billed: insurance claim or benefit":
    "Bil sendiri: tuntutan atau manfaat insurans",
  "Self-billed: capital reduction or return":
    "Bil sendiri: pengurangan atau pemulangan modal",
  "Your supplier issues this note. Record their document number below; EAS does not generate one.":
    "Pembekal anda mengeluarkan nota ini. Rekodkan nombor dokumen mereka di bawah; EAS tidak menjana sebarang nombor.",
  "Enter the number printed on your supplier's note":
    "Masukkan nombor yang tercetak pada nota pembekal anda",
  "Refund (legacy)": "Bayaran Balik (lama)",
  "REFUND (LEGACY)": "BAYARAN BALIK (LAMA)",
  "Add New Refund Note": "Tambah Nota Bayaran Balik Baharu",
  "New Refund Note": "Nota Bayaran Balik Baharu",
  "Issue Refund Note": "Keluarkan Nota Bayaran Balik",
  "Lines to refund": "Baris untuk dibayar balik",
  "Refund method": "Kaedah bayaran balik",
  "From bank": "Dari bank",
  "Not recorded": "Tidak direkodkan",
  "Refunding now": "Dibayar balik sekarang",
  "Cash held after this note": "Tunai dipegang selepas nota ini",
  Refunded: "Dibayar balik",
  Disposition: "Keadaan barang",
  "cancel note": "batal nota",
  "view note": "lihat nota",

  // Debit notes -- milestone 7. An under-billing is corrected by ADDING to the bill, so the copy
  // says charge rather than credit throughout; telling an operator to "credit" a line they are
  // billing for is the kind of instruction that makes people conclude the screen is broken.
  "Debit note": "nota debit",
  "Add New Debit Note": "Tambah Nota Debit Baharu",
  "Record Supplier Debit Note": "Rekod Nota Debit Pembekal",
  "Lines to charge": "Baris untuk dicaj",
  "Issue Debit Note": "Keluarkan Nota Debit",
  "Charge at least one line before issuing the note":
    "Caj sekurang-kurangnya satu baris sebelum mengeluarkan nota",
  "Amount must be a number": "Jumlah mestilah nombor",

  // Partner credit balances -- milestone 8. Value owed BACK to the partner, which is the opposite
  // of the balance the transaction list shows, so the copy never calls it a balance on its own.
  "Credit balance held": "Baki kredit dipegang",
  Credited: "Dikreditkan",
  Allocated: "Diagihkan",
  "Still held": "Masih dipegang",
  Allocations: "Agihan",
  "Applied to": "Digunakan untuk",
  "Apply to invoice": "Guna untuk invois",
  Apply: "Guna",
  allocate: "agih",
  release: "lepaskan",
  RELEASED: "DILEPASKAN",
  APPLIED: "DIGUNAKAN",
  "Release this allocation back to the credit balance?":
    "Lepaskan agihan ini kembali ke baki kredit?",
  "The credit could not be allocated": "Kredit tidak dapat diagihkan",

  // The consolidation deadline banner. Wording follows Specific Guideline v4.7 section 3.6 --
  // seven calendar days after month end -- rather than describing it as a grace period.
  "must be consolidated by": "mesti digabungkan sebelum",
  "was due for consolidation on": "sepatutnya digabungkan pada",
  "documents are still unsubmitted": "dokumen masih belum dihantar",

  "Confirm to cancel this note?": "Sahkan untuk batalkan nota ini?",
  credited: "dikreditkan",

  // The adjustment-note menu and form, renamed and regrouped. The invoice menu names both
  // documents it can raise, and the list button names none of them in particular.
  "credit/debit note": "nota kredit/debit",
  "New Note": "Nota Baharu",
  "Go to credit/debit note list": "Pergi ke senarai nota kredit/debit",
  "Note details": "Butiran nota",
  Item: "Barang",
  Quantity: "Kuantiti",
  "Line value": "Nilai baris",
  "Enter the units to return. The note's value follows from them.":
    "Masukkan unit yang dipulangkan. Nilai nota mengikut unit tersebut.",
  "Enter the units to charge. The note's value follows from them.":
    "Masukkan unit yang dicaj. Nilai nota mengikut unit tersebut.",
  // What each note type does to the bill, said under the picker before it is issued.
  "Reduces the original invoice value. No money is returned.":
    "Mengurangkan nilai asal invois. Tiada wang dikembalikan.",
  "Increases the original invoice value. Use it to bill for something the invoice left out.":
    "Menambah nilai asal invois. Guna untuk mengecaj perkara yang tertinggal daripada invois.",
  "Reduces the original invoice value and returns the money already received.":
    "Mengurangkan nilai asal invois dan memulangkan wang yang telah diterima.",

  // The e-Invoice submission switch in App Setting. Off by default until transmission ships.
  "Enable e-Invoice submission to LHDN":
    "Aktifkan penghantaran e-Invois ke LHDN",
  "Coming soon": "Akan datang",
  "While this is off, submission actions and consolidation deadline warnings are hidden.":
    "Semasa ini dimatikan, tindakan penghantaran dan amaran tarikh akhir penggabungan disembunyikan.",

  // ---- Financial statement pack (income statement, cash flow, balance sheet,
  // ---- trial balance, notes)
  "Financial statement pack": "Pakej penyata kewangan",
  "Financial statements": "Penyata kewangan",
  "Income statement": "Penyata pendapatan",
  "Balance sheet": "Kunci kira-kira",
  "Trial balance": "Imbangan duga",
  Notes: "Nota",
  "Cash flow — indirect": "Aliran tunai — tak langsung",
  "Cash flow — direct": "Aliran tunai — langsung",
  "Statement of cash flows — indirect method":
    "Penyata aliran tunai — kaedah tak langsung",
  "Statement of cash flows — direct method":
    "Penyata aliran tunai — kaedah langsung",
  "Statement of financial position as at": "Penyata kedudukan kewangan pada",
  "Adjusted trial balance before closing entries":
    "Imbangan duga terselaras sebelum catatan penutup",
  "Profit and loss for": "Untung rugi bagi",
  Account: "Akaun",
  Debit: "Debit",
  Credit: "Kredit",
  Change: "Perubahan",
  "As at": "Pada",
  Current: "Semasa",
  Prior: "Sebelumnya",
  "% rev": "% hasil",
  "% of revenue": "% daripada hasil",
  Presentation: "Persembahan",
  "Full amounts": "Jumlah penuh",
  Thousands: "Ribuan",
  Comparative: "Perbandingan",
  "By account": "Ikut akaun",
  "No chart of accounts was returned for this selection":
    "Tiada carta akaun dikembalikan untuk pilihan ini",
  Charts: "Carta",
  "Full pack": "Pakej penuh",
  "Single view": "Paparan tunggal",
  "Print pack": "Cetak pakej",
  "RM, full amounts": "RM, jumlah penuh",
  "RM, thousands": "RM, ribuan",
  "Basis: accrual · management-prepared":
    "Asas: akruan · disediakan oleh pengurusan",
  "comparative with the preceding period":
    "perbandingan dengan tempoh sebelumnya",
  "No comparative period was returned for this selection":
    "Tiada tempoh perbandingan dikembalikan bagi pilihan ini",
  "This statement is not available for the selection.":
    "Penyata ini tidak tersedia bagi pilihan ini.",
  "Revenue to net earnings": "Hasil kepada pendapatan bersih",
  "Where each ringgit of revenue went in the period":
    "Ke mana setiap ringgit hasil pergi dalam tempoh ini",
  "What moved cash": "Apa yang menggerakkan tunai",
  "The three activity groups behind the net movement":
    "Tiga kumpulan aktiviti di sebalik pergerakan bersih",
  "Percent of revenue is calculated on total revenue of":
    "Peratus hasil dikira atas jumlah hasil sebanyak",
  "Total revenue for the period is": "Jumlah hasil bagi tempoh ini ialah",
  "Net earnings carry to equity on the balance sheet and open the indirect cash flow statement. See notes 2 and 8.":
    "Pendapatan bersih dibawa ke ekuiti dalam kunci kira-kira dan membuka penyata aliran tunai tak langsung. Lihat nota 2 dan 8.",
  "Starts from net earnings, adds back depreciation, then adjusts for the movement in each working capital account.":
    "Bermula daripada pendapatan bersih, menambah semula susut nilai, kemudian melaraskan pergerakan setiap akaun modal kerja.",
  "The closing figure is the derived cash position carried to the balance sheet, not a reconciled bank balance. See note 6.":
    "Angka penutup ialah kedudukan tunai terbitan yang dibawa ke kunci kira-kira, bukan baki bank yang telah disesuaikan. Lihat nota 6.",
  "Receipts and payments are shown gross, then reconciled to net earnings at the foot of the statement.":
    "Terimaan dan bayaran ditunjukkan secara kasar, kemudian disesuaikan dengan pendapatan bersih di kaki penyata.",
  "Each line is the accrual figure less the part still unsettled, so both methods reach the same operating cash by construction.":
    "Setiap baris ialah angka akruan tolak bahagian yang masih belum diselesaikan, jadi kedua-dua kaedah mencapai tunai operasi yang sama secara binaan.",
  "Total assets of": "Jumlah aset sebanyak",
  "equal total liabilities of": "sama dengan jumlah liabiliti sebanyak",
  "plus equity of": "campur ekuiti sebanyak",
  "Accumulated depreciation is shown as a deduction from the asset column. See notes 4 and 5.":
    "Susut nilai terkumpul ditunjukkan sebagai tolakan daripada lajur aset. Lihat nota 4 dan 5.",
  "Debits of": "Debit sebanyak",
  "equal credits of": "sama dengan kredit sebanyak",
  "Account codes are a presentation convention applied by this report; EAS holds named totals rather than a chart of accounts. See note 7.":
    "Kod akaun ialah konvensyen persembahan yang digunakan oleh laporan ini; EAS menyimpan jumlah bernama dan bukan carta akaun. Lihat nota 7.",
  "directly from purchase invoices": "terus daripada invois belian",
  "from recorded cost of goods sold":
    "daripada kos barang dijual yang direkodkan",
  // --- Modern invoice form theme ---------------------------------------------
  // The document-style alternative to the classic bill form, and the setting that picks it.
  // Column heads and figure labels are printed on a document a Malay-speaking customer reads,
  // so these are the customer-facing spellings, not literal glosses of the English keys.
  "Invoice form": "Borang invois",
  Classic: "Klasik",
  Modern: "Moden",
  "Both themes record exactly the same invoice. Modern shows the document as the customer receives it.":
    "Kedua-dua tema merekod invois yang sama. Moden memaparkan dokumen seperti yang diterima pelanggan.",
  Bookkeeping: "Perakaunan",
  "Not printed on the invoice": "Tidak dicetak pada invois",
  "You are editing the invoice itself — this is what the customer receives.":
    "Anda sedang mengedit invois itu sendiri — inilah yang diterima pelanggan.",
  "Reissues every month": "Dikeluarkan semula setiap bulan",
  "Issued once": "Dikeluarkan sekali sahaja",
  "No.": "No.",
  "Assigned on save": "Diberikan semasa disimpan",
  "On receipt": "Sebaik diterima",
  "Net 7": "Net 7",
  "Net 14": "Net 14",
  "Net 30": "Net 30",
  "Pick a term, or set the date directly.":
    "Pilih terma, atau tetapkan tarikh secara terus.",
  "Payable on receipt.": "Perlu dibayar sebaik diterima.",
  "Payable within": "Perlu dibayar dalam tempoh",
  days: "hari",
  "Amount due": "Jumlah kena bayar",
  Outstanding: "Belum dijelaskan",
  "Outstanding · no due date set":
    "Belum dijelaskan · tiada tarikh akhir ditetapkan",
  "Settled in full": "Dijelaskan sepenuhnya",
  received: "diterima",
  outstanding: "belum dijelaskan",
  "Invoice lines": "Baris invois",
  Description: "Perihal",
  "Add a note": "Tambah nota",
  Sku: "Sku",
  "In Charge": "Bertanggungjawab",
  "Product Qty": "Kuantiti produk",
  Price: "Harga",
  Discount: "Diskaun",
  "Discount type": "Jenis diskaun",
  type: "jenis",
  Percent: "Peratus",
  flat: "tetap",
  Subtotal: "Jumlah kecil",
  "Note to customer": "Nota kepada pelanggan",
  "Standard terms": "Terma standard",
  "From project settings": "Daripada tetapan projek",
  "No standard terms set for this project.":
    "Tiada terma standard ditetapkan untuk projek ini.",
  "Issued by": "Dikeluarkan oleh",
  "Reg. no.": "No. pendaftaran",
  Tel: "Tel",
  "This document is computer generated.": "Dokumen ini dijana oleh komputer.",
  "Payment Details": "Butiran pembayaran",
  "This payment is recorded together with the invoice.":
    "Pembayaran ini direkodkan bersama invois.",
  "*receipt will be attached to the payment":
    "*resit akan dilampirkan pada pembayaran",
  "Select method made": "Pilih kaedah pembayaran",
  "Still needed": "Masih diperlukan",
  "Ready to create.": "Sedia untuk dibuat.",
  "Ready to save.": "Sedia untuk disimpan.",
  Discard: "Buang",
  Saving: "Menyimpan",
  // --- Customer view (modern invoice preview) ---
  "Edit invoice": "Edit invois",
  "Customer view": "Paparan pelanggan",
  "Edit the invoice itself.": "Edit invois itu sendiri.",
  "Exactly what the customer receives.":
    "Tepat seperti yang diterima pelanggan.",
  "Read-only. This is the document your customer receives.":
    "Baca sahaja. Inilah dokumen yang diterima pelanggan anda.",
  View: "Paparan",
  "Bill to": "Bil kepada",
  "Customer not selected": "Pelanggan belum dipilih",
  "Amount paid": "Jumlah dibayar",
  "Untitled line": "Baris tanpa nama",
  "Payments received": "Pembayaran diterima",
  entry: "entri",
  entries: "entri",
  Payment: "Pembayaran",
  "Method not recorded": "Kaedah tidak direkodkan",
  "Leave 0 if nothing has been paid yet": "Biarkan 0 jika belum ada bayaran",
  "Leave empty if nothing has been paid yet":
    "Biarkan kosong jika belum ada bayaran",
  "Record the full amount": "Rekod jumlah penuh",
  Overpaid: "Terlebih bayar",
  "Set for you when the amount recorded is less than the total.":
    "Ditetapkan untuk anda apabila jumlah direkod kurang daripada jumlah keseluruhan.",
  "hide details": "sembunyi butiran",

  /* ---- dashboard: the command centre ---- */
  "Command centre": "Pusat kawalan",
  "Dashboard detail": "Butiran papan pemuka",
  "Reporting period": "Tempoh pelaporan",
  "Reading the ledger…": "Membaca lejar…",
  "book(s)": "buku akaun",
  "the period before": "tempoh sebelumnya",
  "The dashboard could not be read. Reload the page, or open the report pack for the same period.":
    "Papan pemuka tidak dapat dibaca. Muat semula halaman, atau buka pakej laporan bagi tempoh yang sama.",
  "This month": "Bulan ini",
  "Last month": "Bulan lepas",
  "Year to date": "Tahun sehingga kini",
  "Net position": "Kedudukan bersih",
  "Net profit": "Untung bersih",
  "Cash on hand": "Tunai di tangan",
  "Owed to you": "Terhutang kepada anda",
  "You owe": "Anda terhutang",
  Revenue: "Hasil",
  "Gross margin": "Margin kasar",
  "Ledger totals": "Jumlah lejar",
  "Paid against booked": "Dibayar berbanding direkod",
  "still moving through these ledgers": "masih bergerak dalam lejar ini",
  Trading: "Perniagaan",
  "Other movements": "Pergerakan lain",
  Funding: "Pembiayaan",
  "fully settled": "dijelaskan sepenuhnya",
  "Needs action": "Perlu tindakan",
  "of value sitting in these lines": "nilai berada dalam baris ini",
  "Invoices overdue more than 30 days": "Invois tertunggak melebihi 30 hari",
  "Money earned and not collected": "Wang diperoleh tetapi belum dikutip",
  "Supplier bills overdue more than 30 days":
    "Bil pembekal tertunggak melebihi 30 hari",
  "Owed to suppliers past terms": "Terhutang kepada pembekal melepasi terma",
  "Quotations still open": "Sebut harga masih terbuka",
  "Offered and not yet accepted": "Ditawarkan dan belum diterima",
  "Sale orders not yet invoiced": "Pesanan jualan belum diinvois",
  "Work committed and not yet billed": "Kerja dikomitkan dan belum dibilkan",
  "Borrowings outstanding": "Pinjaman belum dijelaskan",
  "Principal still to repay": "Prinsipal yang masih perlu dibayar",
  Position: "Kedudukan",
  "Daily sales": "Jualan harian",
  Cash: "Tunai",
  "Receivables & payables": "Belum terima & belum bayar",
  Projects: "Projek",
  "What you own, what you owe": "Apa yang anda miliki, apa yang anda hutang",
  "Both bars are to one scale, so the gap between them is the net position.":
    "Kedua-dua bar menggunakan skala yang sama, jadi jurang antaranya ialah kedudukan bersih.",
  "Nothing has been posted in this period to position yet.":
    "Belum ada rekod dalam tempoh ini untuk membentuk kedudukan.",
  "Fixed assets": "Aset tetap",
  Receivables: "Belum terima",
  Stock: "Stok",
  Prepayments: "Bayaran pendahuluan",
  Borrowings: "Pinjaman",
  Payables: "Belum bayar",
  Accruals: "Akruan",
  "Deposits held": "Deposit dipegang",
  "Credit balances": "Baki kredit",
  "Dividend payable": "Dividen belum bayar",
  "Capital returnable": "Modal boleh dipulangkan",
  "Owner capital": "Modal pemilik",
  "Retained earnings": "Pendapatan tertahan",
  "Where the revenue went": "Ke mana hasil pergi",
  "broken into cost, overheads and what is left.":
    "dipecahkan kepada kos, overhed dan bakinya.",
  "No revenue was invoiced in this period.":
    "Tiada hasil diinvoiskan dalam tempoh ini.",
  "Cost of sales": "Kos jualan",
  "Operating expenses": "Belanja operasi",
  "Depreciation and refunds": "Susut nilai dan bayaran balik",
  "Spend by account": "Perbelanjaan mengikut akaun",
  "No expenses were booked in this period.":
    "Tiada belanja direkod dalam tempoh ini.",
  "Sales by day": "Jualan mengikut hari",
  "days had a sale": "hari ada jualan",
  "best day": "hari terbaik",
  Difference: "Perbezaan",
  "No sales were invoiced in this period or the one before it.":
    "Tiada jualan diinvoiskan dalam tempoh ini mahupun tempoh sebelumnya.",
  against: "berbanding",
  day: "hari",
  "Cash position": "Kedudukan tunai",
  "As at the end of the period": "Pada akhir tempoh",
  "Cash and bank": "Tunai dan bank",
  "The same figure the balance sheet carries and the cash flow statement closes on.":
    "Angka yang sama seperti dalam kunci kira-kira dan penutup penyata aliran tunai.",
  "Runway at this period's burn":
    "Jangka hayat tunai pada kadar perbelanjaan tempoh ini",
  months: "bulan",
  Against: "Berbanding",
  "of cost over": "kos sepanjang",
  "Cash in and out": "Tunai masuk dan keluar",
  "Classified as the cash flow statement classifies it":
    "Dikelaskan sepertimana penyata aliran tunai mengelaskannya",
  "Operating activities": "Aktiviti operasi",
  "Trading: customers, suppliers, staff and overheads":
    "Perniagaan: pelanggan, pembekal, pekerja dan overhed",
  "Investing activities": "Aktiviti pelaburan",
  "Assets bought and sold": "Aset dibeli dan dijual",
  "Financing activities": "Aktiviti pembiayaan",
  "Borrowing, owner capital and distributions":
    "Pinjaman, modal pemilik dan agihan",
  "Net movement in cash": "Pergerakan bersih tunai",
  "Receivables — money owed to you":
    "Belum terima — wang terhutang kepada anda",
  "Payables — money you owe": "Belum bayar — wang yang anda hutang",
  "Nothing is outstanding on this side of the ledger.":
    "Tiada baki tertunggak di sebelah lejar ini.",
  "is past 30 days": "melepasi 30 hari",
  "A further": "Tambahan",
  "on this line carries no due date and cannot be aged; the bands and this figure together are the balance sheet line.":
    "pada baris ini tiada tarikh akhir dan tidak boleh diumurkan; jalur dan angka ini bersama-sama ialah baris kunci kira-kira.",
  "Not yet due": "Belum cukup tempoh",
  "1–30 days": "1–30 hari",
  "31–60 days": "31–60 hari",
  "61–90 days": "61–90 hari",
  "Over 90 days": "Melebihi 90 hari",
  "Margin by project": "Margin mengikut projek",
  projects: "projek",
  revenue: "hasil",
  cost: "kos",
  margin: "margin",
  unpaid: "belum dibayar",
  "No project booked revenue or cost in this period.":
    "Tiada projek merekod hasil atau kos dalam tempoh ini.",
  "Top customers": "Pelanggan utama",
  "No customer was invoiced in this period.":
    "Tiada pelanggan diinvoiskan dalam tempoh ini.",
  Pipeline: "Saluran paip",
  "Offered and committed — not revenue, and not owed":
    "Ditawarkan dan dikomitkan — bukan hasil, dan bukan hutang",
  "Open quotations": "Sebut harga terbuka",
  "Sale orders": "Pesanan jualan",
  "Committed, not yet invoiced": "Dikomitkan, belum diinvois",
  "Purchase orders": "Pesanan belian",
  "Ordered from suppliers": "Dipesan daripada pembekal",

  /* ---- dashboard: the needs-action drawer ---- */
  Chase: "Kejar",
  Settle: "Jelaskan",
  "Follow up": "Susul",
  Review: "Semak",
  Open: "Buka",
  "Open document": "Buka dokumen",
  Close: "Tutup",
  document: "dokumen",
  documents: "dokumen",
  "making up this figure": "membentuk angka ini",
  "no number": "tiada nombor",
  "face value": "nilai muka",
  "Offered and not yet accepted. Neither revenue nor money owed.":
    "Ditawarkan dan belum diterima. Bukan hasil, bukan juga hutang.",
  "Work committed and not yet billed. Neither revenue nor money owed.":
    "Kerja dikomitkan dan belum dibilkan. Bukan hasil, bukan juga hutang.",
  "What has been drawn, less principal already repaid.":
    "Jumlah yang telah dikeluarkan, ditolak prinsipal yang telah dibayar.",
  "Scheduled repayments still outstanding.":
    "Bayaran balik berjadual yang masih tertunggak.",
  drawn: "dikeluarkan",
  scheduled: "berjadual",
  open: "terbuka",
  unpaid: "belum dibayar",
  partial: "sebahagian",
};
